import { createAction } from '@reduxjs/toolkit';
import { storeName } from '../config';

export const hideToast = createAction(`${storeName}/setClose`);
